export default __webpack_public_path__ + "static/N0317-6d9633dd29f2b29ca61da7d78b4f2ed9.png";